import React, { useContext, useState } from "react";
import { View, Text, Image, TouchableOpacity, Dimensions } from "react-native";
import { useColorScheme } from "react-native-appearance";
import { colors } from "../context/Colors";
// import MiniAudioPlayer from "./MiniAudioPlayer";
import Letter from "./Letter";
import AppContext from "../context";
// import ImageView from "react-native-image-viewing";
import { isTablet } from "react-native-device-info";

export default function InventoryObject({ o, noText }) {
  const theme = useColorScheme() === "dark" ? "dark" : "light";
  const { resolveURL, dict } = useContext(AppContext);
  const [big, setBig] = useState(false);

  // console.log(o);
  if (o.objectType === "Object")
    return (
      <View style={{ alignItems: 'center' }}>
        <TouchableOpacity onPress={() => setBig(true)}>
          <Image
            source={{
              uri: resolveURL('game', o.objectBlobReference, 300)
            }}
            style={{
              width: isTablet()
                ? Dimensions.get('screen').width / 2 - 100
                : Dimensions.get('screen').width * 0.9 - 40,
              height: 200
            }}
            resizeMode={'contain'}
          />
        </TouchableOpacity>
        {/* <ImageView
          images={[{ uri: resolveURL("game", o.objectBlobReference, 600) }]}
          imageIndex={0}
          visible={big}
          onRequestClose={() => setBig(false)}
        /> */}
        {!noText ? (
          <>
            <Text
              style={{
                fontSize: 17,
                textAlign: 'center',
                color: colors[theme].text,
                marginTop: 20,
                opacity: 0.6,
                fontWeight: '600'
              }}
            >
              {o.objectName}
            </Text>
            <Text
              style={{
                fontSize: 14,
                textAlign: 'center',
                color: colors[theme].text,
                marginBottom: 20,
                marginTop: 10,
                marginLeft:10,  
                marginRight:10,
                maxWidth: 300
              }}
            >
              {o.objectDescription}
            </Text>
          </>
        ) : null}
      </View>
    );

  if (o.objectType === "Text")
    return (
      <View style={{ alignItems: "center" }}>
        <Image
          source={require("../assets/message.png")}
          style={{ width: 112, height: 114 }}
        />
        {!noText ? (
          <>
            <Text
              style={{
                fontSize: 17,
                textAlign: "center",
                color: colors[theme].text,
                marginTop: 20,
                opacity: 0.6,
                fontWeight: "600",
              }}
            >
              {o.objectName}
            </Text>
            <Text
              style={{
                fontSize: 14,
                textAlign: "center",
                color: colors[theme].text,
                marginBottom: 20,
                marginTop: 10,
              }}
            >
              {o.objectDescription}
            </Text>
          </>
        ) : null}
      </View>
    );

  if (o.objectType === "Audio")
    return (
      <View style={{ alignItems: "center" }}>
        <Image
          source={require("../assets/audio.png")}
          style={{ width: 135, height: 117 }}
        />
        {!noText ? (
          <>
            <Text
              style={{
                fontSize: 17,
                textAlign: "center",
                color: colors[theme].text,
                marginTop: 20,
                opacity: 0.6,
                fontWeight: "600",
              }}
            >
              {o.objectName}
            </Text>
            <Text
              style={{
                fontSize: 14,
                textAlign: "center",
                color: colors[theme].text,
                marginBottom: 20,
                marginTop: 10,
              }}
            >
              {o.objectDescription}
            </Text>
          </>
        ) : null}
        {/* {!noText ? <MiniAudioPlayer audio={o.objectBlobReference} /> : null} */}
      </View>
    );

  if (o.objectType === "Letter")
    return (
      <View style={{ alignItems: "center" }}>
        <Letter l={o.objectName} size={120} />
        {/* <FastImage
          source={{
            uri: 'https://studio.guidigo.com/Image/Letter/?id=' + o.objectName
          }}
          style={{ width: 120, height: 120 }}
        /> */}
        <Text
          style={{
            fontSize: 17,
            textAlign: "center",
            color: colors[theme].text,
            marginTop: 20,
            opacity: 0.6,
            fontWeight: "600",
          }}
        >
          {dict.letter_number}
        </Text>
      </View>
    );
  if (o.objectType === "Puzzle")
    return (
      <View style={{ alignItems: "center" }}>
        <Image
          source={{
            uri: resolveURL("game", o.objectBlobReference, 150),
          }}
          style={{
            width: 150,
            height: 150,
            borderColor: "#FFF",
            borderWidth: 1,
          }}
          resizeMode={"contain"}
        />
        <Text
          style={{
            fontSize: 17,
            textAlign: "center",
            color: colors[theme].text,
            marginTop: 20,
            opacity: 0.6,
            fontWeight: "600",
          }}
        >
          {dict.puzzle_piece}
        </Text>
      </View>
    );

  return (
    <View>
      <Text>Unknown object type.</Text>
    </View>
  );
}
